import React, {ReactNode, ReactElement} from 'react';
import {CustomIcon} from '../CustomIcon';
import clsx from 'clsx';
import {
  Box,
  CheckboxWrapper,
  CheckedRoundCheckbox,
  Content,
  Label,
  ErrorMessage,
} from './styled';

type CheckboxProps = {
  onChange?: (checked?: boolean) => void;
  label?: string | ReactNode | ReactElement;
  disabled?: boolean;
  value?: boolean;
  round?: boolean;
  className?: string;
  error?: string;
  name?: string;
  content?: string | ReactNode | ReactElement;
};

export const Checkbox = React.forwardRef<HTMLDivElement, CheckboxProps>(
  (
    {onChange = () => {}, label, disabled, value, className, name, error, round, content},
    ref,
  ) => {
    const [isChecked, setIsChecked] = React.useState(value);
    const handleChange = () => {
      if (disabled) return;
      setIsChecked(!isChecked);
      onChange(!isChecked);
    };

    return (
      <>
        <CheckboxWrapper
          onClick={handleChange}
          disabled={disabled}
          role="checkbox"
          aria-label={name}
          ref={ref}
          className={clsx(className, 'checkbox')}
        >
          {round ? (
            <Box checked={value} round={round} className="checkbox__round-box">
              {value && <CheckedRoundCheckbox data-testid={`${name}-checkmark`} />}
            </Box>
          ) : (
            <Box checked={value} className="checkbox__box">
              {value && <CustomIcon name="checkFill" color="white" size={20} />}
            </Box>
          )}
          <div className="checkbox__content-wrapper">
            {label && <Label className="checkbox__label">{label}</Label>}
            <Content className="checkbox__content">{content}</Content>
          </div>
        </CheckboxWrapper>
        {error && (
          <ErrorMessage className="error-message" data-testid={`${name}-error`}>
            {error}
          </ErrorMessage>
        )}
      </>
    );
  },
);
